<template>
    <div>
        <span class="timeline-key">Arrived country </span>: {{extra.country}}<br>
        <span class="timeline-key">Arrived from </span>: {{extra.office.name}}<br>
        <span class="timeline-key">Date of entry </span>: {{extra.date_of_entry}}<br>
        <span class="timeline-key">Purpose of visit </span>: {{extra.purpose_of_visit}}<br>
        <span class="timeline-key">User image </span>: <file-display :src="extra.image"></file-display>

    </div>
</template>

<script>
    import FileDisplay from "../../FileDisplay";

    export default {
        name: "AppliedForArrivalCertification",
        props: ['extra', 'days', 'user'],
        components: {FileDisplay},
    }
</script>
